<template>
  <table class="min-w-full overflow-hidden divide-y divide-gray-200 rounded-lg">
    <thead>
      <tr
        class="
          text-xs
          font-medium
          text-left text-gray-500
          uppercase
          bg-gray-100
        "
      >
        <th
          class="px-6 py-3 sm:table-cell hidden"
          v-for="(head, index) in header"
          :key="index"
          :class="head.class"
        >
          {{ head.title }}
        </th>
      </tr>
    </thead>
    <tbody>
      <td :colspan="header.length" v-if="loading">
        <PuSkeleton>
          <span class="py-1 pu-skeleton" style="height: 2.5rem"></span>
          <span class="py-1 pu-skeleton" style="height: 2.5rem"></span>
        </PuSkeleton>
      </td>
      <td
        :colspan="header.length"
        v-if="row.length == 0 && !loading"
        class="px-6 py-2 bg-gray-50"
      >
        {{ emptyMessage }}
      </td>
      <tr
        :class="index % 2 == 0 ? 'bg-gray-50' : 'bg-gray-100'"
        v-for="(r, index) in row"
        :key="index"
        class="table-row sm:border-0 border-b border-gray-200"
      >
        <div
          v-for="(e, index2) in r"
          :key="index2"
          class="sm:table-cell table-row align-middle"
        >
          <td
            class="
              px-6
              py-4
              text-xs
              font-medium
              border-r border-gray-200
              bg-gray-100
              sm:hidden
              text-left text-gray-500
              uppercase
              align-middle
            "
          >
            {{ header[index2].title }}
          </td>
          <div
            class="
              px-6
              py-4
              text-sm
              font-medium
              leading-5
              text-gray-900
              whitespace-no-wrap
              table-cell
              sm:block
              align-middle
            "
            :class="e.class"
          >
            <template v-if="e.type == 'date'">
              {{ e.data | formatDate }}
            </template>
            <template v-else-if="e.type == 'price'">
              {{ e.data | price }} {{ e.currency }}
            </template>
            <div v-else v-html="e.data" class="inline-block"></div>
          </div>
        </div>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: ["header", "row", "loading", "emptyMessage"],
  data() {
    return {};
  },
};
</script>

<style scoped>
@media (max-width: 640px) {
  .table-row .table-cell {
    text-align: left;
  }
}
</style>